import { useState, useEffect } from 'react';

/**
 * Custom hook that exposes our ideas about window sizing to other components
 */
// eslint-disable-next-line import/prefer-default-export
export const useWindowSizing = () => {
  const [sizing, setSizing] = useState({ isMediumScreen: false, isLargeScreen: false });

  useEffect(() => {
    const updateScreenSize = () => {
      const isMediumScreen = window.matchMedia('(min-width: 768px)').matches;
      const isLargeScreen = window.matchMedia('(min-width: 992px)').matches;
      const isSmallScreen = !isMediumScreen && !isLargeScreen;
      setSizing({ isSmallScreen, isMediumScreen, isLargeScreen });
    };

    window.addEventListener('resize', updateScreenSize);

    return () => {
      window.removeEventListener('resize', updateScreenSize);
    };
  });

  return sizing;
};
